import { useState, useEffect } from 'react';
import { requestStatuses } from '../constants/store';

/**
 loadData returns Promise
*/
const useLoadingState = (loadData, reloadData = null, autoLoad = true) => {
  const [status, setStatus] = useState(requestStatuses.INIT);
  const [error, setError] = useState(null);

  const defaultConfig = { backgroundMode: false };

  const runLoad = (doLoad, config = defaultConfig) => {
    const { backgroundMode } = config;

    if (backgroundMode) {
      setStatus(requestStatuses.PENDING);
      setError(null);
    }
    doLoad()
      .then(() => {
        setStatus(requestStatuses.SUCCESS);
      })
      .catch((error) => {
        console.log('Data loading error', error);
        setError(error);
        setStatus(requestStatuses.FAILED);
      });
  };

  useEffect(() => {
    if (!autoLoad) {
      return;
    }
    runLoad(loadData);
  }, []);

  const refreshData = (config) => {
    if (!reloadData) {
      return;
    }
    runLoad(reloadData, config);
  };

  return { status, error, refreshData };
};

export default useLoadingState;
